// AI чат (зөвхөн админ): монголоор асууж, баазаас тайлан авна. Зөвхөн уншина — өгөгдөл өөрчлөхгүй.
// Асуулт бүрийн токен/$ зардал (өдрийн хязгааргүй, кредит дууссан бол мэдэгдэнэ); ажиллуулсан асуулга бүрийг Excel-ээр бүтнээр нь татна.
// mobile — мобайл горимд (/m/ai, доод таб) утасны дэлгэцэнд тааруулсан хувилбар.
import React, { useEffect, useRef, useState } from "react";
import { Button, Drawer, Input, Select, Tag, Tooltip, message } from "antd";
import { DownloadOutlined, SendOutlined } from "@ant-design/icons";
import { useAiModel } from "utils/aiBus";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";
import { instance } from "utils/axios";
import { mdToHtml, printPdf, saveWord } from "components/AiPanel/files";

const EXAMPLES = [
  "Passion Program-д хөтөлбөр тус бүрээр хэдэн хүүхэд бүртгүүлснийг ангиар гарга",
  "Энэ долоо хоногт хамгийн олон тасалсан 10 сурагч",
  "Анги бүрийн идэвхтэй сурагчийн тоо",
  "Энэ сард бүртгэгдсэн зөрчлүүдийг төрлөөр нь",
];
const usd = (n) => `$${Number(n || 0).toFixed(n >= 1 ? 2 : 3)}`;

// Markdown — HTML-ийг рендерлэхгүй (react-markdown анхнаасаа аюулгүй), хүснэгтийг antd-тэй төстэй
const md = {
  table: (p) => <div className="overflow-x-auto my-2"><table className="text-sm border-collapse min-w-full" {...p} /></div>,
  th: (p) => <th className="text-left font-semibold bg-gray-50 border border-gray-200 px-2 py-1 whitespace-nowrap" {...p} />,
  td: (p) => <td className="border border-gray-200 px-2 py-1 align-top" {...p} />,
  p: (p) => <p className="my-1.5 leading-relaxed" {...p} />,
  ul: (p) => <ul className="my-1.5 pl-5 list-disc" {...p} />,
  ol: (p) => <ol className="my-1.5 pl-5 list-decimal" {...p} />,
  code: (p) => <code className="text-[12px] bg-gray-100 rounded px-1" {...p} />,
  a: ({ children }) => <span className="underline">{children}</span>,
};

// Хариултыг хуулах (Docs/Word-д хүснэгттэйгээ буудаг) эсвэл Word / PDF болгох — AI зардалгүй
function AnswerTools({ r }) {
  const title = String(r.question || "AI хариу").split("\n")[0].slice(0, 60);
  const doc = { filename: title, title: null, markdown: r.answer };
  const copy = async () => {
    try {
      if (window.ClipboardItem) {
        await navigator.clipboard.write([new window.ClipboardItem({ "text/html": new Blob([mdToHtml(r.answer)], { type: "text/html" }), "text/plain": new Blob([r.answer], { type: "text/plain" }) })]);
      } else await navigator.clipboard.writeText(r.answer);
      message.success("Хууллаа");
    } catch (e) { message.error("Хуулж чадсангүй"); }
  };
  const pdf = () => { try { printPdf(doc); } catch (e) { message.error(e.message); } };
  return (
    <div className="flex flex-wrap gap-1.5">
      <Button size="small" onClick={copy}>Хуулах</Button>
      <Button size="small" icon={<DownloadOutlined />} onClick={() => saveWord(doc)}>Word</Button>
      <Button size="small" icon={<DownloadOutlined />} onClick={pdf}>PDF</Button>
    </div>
  );
}

export function Answer({ r }) {
  const [busy, setBusy] = useState(-1);
  const excel = (i) => {
    setBusy(i);
    instance({ method: "get", url: `/ai/logs/${r.id}/rows`, params: { i }, noMessage: true })
      .then(({ data }) => {
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data.rows, { header: data.columns }), "Тайлан");
        saveAs(new Blob([XLSX.write(wb, { type: "array", bookType: "xlsx" })]), `${(data.purpose || "AI тайлан").replace(/[\\/:*?"<>|]/g, " ")}.xlsx`);
        if (data.rowCount > data.rows.length) message.info(`Эхний ${data.rows.length} мөрийг татлаа (нийт ${data.rowCount})`);
      })
      .catch((e) => message.error(e?.response?.data?.error || "Татаж чадсангүй"))
      .then(() => setBusy(-1));
  };
  const ok = (r.queries || []).map((q, i) => ({ ...q, i })).filter((q) => !q.error && q.rows > 0);
  return (
    <div className="flex flex-col gap-2">
      <div className="text-[14px] text-gray-800 ai-answer"><ReactMarkdown remarkPlugins={[remarkGfm]} components={md}>{r.answer || ""}</ReactMarkdown></div>
      {ok.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {ok.map((q) => (
            <Tooltip key={q.i} title={<pre className="text-[11px] m-0 whitespace-pre-wrap">{q.sql}</pre>} overlayStyle={{ maxWidth: 560 }}>
              <Button size="small" icon={<DownloadOutlined />} loading={busy === q.i} onClick={() => excel(q.i)}>
                Excel · {q.purpose || `Асуулга ${q.i + 1}`} ({q.rows})
              </Button>
            </Tooltip>
          ))}
        </div>
      )}
      {r.status === "ok" && String(r.answer || "").length > 200 && <AnswerTools r={r} />}
      <div className="text-[11px] text-gray-400">
        Зарцуулалт: {usd(r.costUsd)}
        {r.status === "limit" && <Tag color="orange" className="ml-2">Кредит / хязгаар</Tag>}
        {r.status === "error" && <Tag color="red" className="ml-2">Алдаа</Tag>}
      </div>
    </div>
  );
}

export default function AiChat({ mobile = false }) {
  const [logs, setLogs] = useState([]);
  const [thread, setThread] = useState([]); // [{ id, question, answer, status, ... }]
  const [q, setQ] = useState("");
  const [sending, setSending] = useState(false);
  const [tick, setTick] = useState(0);
  const [histOpen, setHistOpen] = useState(false);
  const { models, model, setModel } = useAiModel(instance);
  const end = useRef(null);
  const pending = thread.find((t) => t.status === "running");

  const loadMeta = () => {
    instance({ method: "get", url: "/ai/logs", noMessage: true }).then((r) => setLogs(r.data)).catch(() => {});
  };
  useEffect(loadMeta, []);
  useEffect(() => { end.current?.scrollIntoView({ behavior: "smooth", block: "end" }); }, [thread.length, pending?.status]);

  // Хариу хүлээх: 3 сек тутам шалгана
  useEffect(() => {
    if (!pending) return undefined;
    const t = setInterval(() => {
      setTick((x) => x + 1);
      instance({ method: "get", url: `/ai/logs/${pending.id}`, noMessage: true }).then(({ data }) => {
        if (data.status === "running") return;
        setThread((th) => th.map((x) => (x.id === data.id ? data : x)));
        loadMeta();
      }).catch(() => {});
    }, 3000);
    return () => clearInterval(t);
  }, [pending?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const ask = (text) => {
    const question = (text ?? q).trim();
    if (question.length < 3 || pending || sending) return;
    setSending(true);
    const history = thread.filter((t) => t.status === "ok").slice(-4).map((t) => ({ q: t.question, a: t.answer }));
    const conversationId = [...thread].reverse().find((t) => t.conversationId)?.conversationId || null;
    instance({ method: "post", url: "/ai/ask", data: { question, history, conversationId, model }, noMessage: true })
      .then(({ data }) => { setThread((th) => [...th, { id: data.id, conversationId: data.conversationId, question, status: "running", createdAt: new Date() }]); setQ(""); setTick(0); })
      .catch((e) => message.error(e?.response?.data?.error || "Илгээж чадсангүй"))
      .then(() => setSending(false));
  };
  const open = (id) => instance({ method: "get", url: `/ai/logs/${id}`, noMessage: true })
    .then(({ data }) => setThread((th) => (th.some((x) => x.id === id) ? th : [...th, data]))).catch(() => {});

  // limit null = хязгааргүй; кредит дууссан үед хариулт дээр мэдэгдэнэ
  const exhausted = false; // өдрийн хязгааргүй (кредит дууссан бол хариулт дээр шошго гарна)

  const examples = !thread.length && (
    <div className={`${mobile ? "" : "m-auto max-w-lg py-10"} text-center flex flex-col gap-3`}>
      <div className="text-gray-500 text-sm">Жишээ асуултууд:</div>
      {EXAMPLES.map((e) => <Button key={e} className="!whitespace-normal !h-auto py-2 text-left" disabled={exhausted} onClick={() => ask(e)}>{e}</Button>)}
    </div>
  );
  const messages = thread.map((t) => (
    <div key={t.id} className="flex flex-col gap-2">
      <div className="self-end max-w-[85%] rounded-2xl rounded-br-sm bg-primary text-white px-3 py-2 text-[14px] whitespace-pre-wrap">{t.question}</div>
      <div className="max-w-full">
        {t.status === "running"
          ? <div className="text-sm text-gray-500 animate-pulse">Баазаас тайлан бэлдэж байна… {tick * 3}с</div>
          : <Answer r={t} />}
      </div>
    </div>
  ));
  const input = (
    <div className="flex gap-2 items-end">
      <Input.TextArea value={q} onChange={(e) => setQ(e.target.value)} autoSize={{ minRows: 1, maxRows: mobile ? 4 : 5 }} maxLength={20000}
        placeholder={exhausted ? "Өнөөдрийн хязгаар дууссан — маргааш дахин асууна уу" : mobile ? "Асуултаа бичнэ үү…" : "Асуултаа бичнэ үү… (Enter — илгээх, Shift+Enter — шинэ мөр)"}
        disabled={exhausted} aria-label="Асуулт"
        onPressEnter={(e) => { if (!mobile && !e.shiftKey) { e.preventDefault(); ask(); } }} />
      {models && <Select value={model} onChange={setModel} aria-label="AI загвар" className="w-[120px] shrink-0" options={models.map((m) => ({ value: m.id, label: m.label, title: m.note }))} />}
      <Button type="primary" icon={<SendOutlined />} loading={sending} disabled={!!pending || exhausted || q.trim().length < 3} onClick={() => ask()} aria-label="Асуух">{mobile ? null : "Асуух"}</Button>
    </div>
  );
  const history = (
    <div className="flex flex-col gap-1">
      {logs.map((l) => (
        <button key={l.id} type="button" onClick={() => { open(l.id); setHistOpen(false); }}
          className="text-left rounded-lg border border-gray-200 bg-white hover:border-primary px-2.5 py-2 cursor-pointer">
          <div className="text-[13px] text-gray-800 line-clamp-2">{l.question}</div>
          <div className="text-[11px] text-gray-400 mt-0.5">
            {[l.lastName?.[0] && `${l.lastName[0]}.`, l.firstName].filter(Boolean).join(" ")} · {moment(l.createdAt).format("MM/DD HH:mm")} · {usd(l.costUsd)}
            {l.status !== "ok" && l.status !== "running" ? ` · ${l.status === "limit" ? "хязгаар" : "алдаа"}` : ""}
          </div>
        </button>
      ))}
      {!logs.length && <div className="text-xs text-gray-400">Одоогоор асуулт алга</div>}
    </div>
  );

  // Утас (/m/ai): хуудас бүхэлдээ гүйлгэнэ, асуух талбар доод табын дээр бэхлэгдэнэ, түүх доороос гарна
  if (mobile) {
    return (
      <div className="flex flex-col gap-4 pt-3 pb-24">
        <div className="flex items-center justify-between gap-2">
          <div>
            <h1 className="text-xl font-bold text-primary m-0">AI чат</h1>
          </div>
          <div className="flex gap-1">
            {thread.length > 0 && <Button size="small" disabled={!!pending} onClick={() => setThread([])}>Шинэ</Button>}
            <Button size="small" onClick={() => setHistOpen(true)}>Түүх</Button>
          </div>
        </div>
        {examples}
        {messages}
        <div ref={end} />
        <div className="fixed inset-x-0 z-40 bg-white border-t border-gray-100 px-3 py-2" style={{ bottom: "calc(64px + var(--safe-bottom, 0px))" }}>
          <div className="max-w-2xl mx-auto">{input}</div>
        </div>
        <Drawer open={histOpen} onClose={() => setHistOpen(false)} placement="bottom" height="75%" title="Сүүлийн асуултууд" bodyStyle={{ padding: 12 }}>{history}</Drawer>
      </div>
    );
  }

  return (
    <div className="p-6 flex flex-col gap-4">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl page-title m-0">AI чат</h1>
          <p className="text-sm text-gray-600 mt-1 mb-0">Монголоор асууж тайлан аваарай. Зөвхөн баазаас уншина — юу ч өөрчлөхгүй. Тайлан бүрийг Excel-ээр бүтнээр нь татаж болно.</p>
        </div>
      </div>

      <div className="grid gap-4 lg:grid-cols-[1fr_280px]">
        <div className="flex flex-col rounded-xl border border-gray-200 bg-white min-h-[60vh]">
          <div className="flex-1 flex flex-col gap-5 p-4 overflow-y-auto max-h-[70vh]">
            {examples}
            {messages}
            <div ref={end} />
          </div>
          <div className="border-t border-gray-200 p-3">{input}</div>
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold">Сүүлийн асуултууд</span>
            {thread.length > 0 && <Button size="small" type="link" disabled={!!pending} onClick={() => setThread([])}>Шинэ яриа</Button>}
          </div>
          <div className="max-h-[70vh] overflow-y-auto">{history}</div>
        </div>
      </div>
    </div>
  );
}
